import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FAQs() {
  const [expandedFAQ, setExpandedFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "How does the 2% daily profit target work?",
      answer: "Our system identifies strong favorites using strict qualifying criteria. Combined with our professional staking plan, we guide you on how to achieve a 2% profit on your account balance each day. While this may seem modest, when compounded over time, it can lead to significant growth."
    },
    {
      question: "What is the staking plan?",
      answer: "Our staking plan is designed to help you calculate the optimal bet size for each race, ensuring you never risk too much of your account balance. It takes into account your current balance, your win/loss record and your daily profit target to determine the appropriate stake for each bet."
    },
    {
      question: "How do I access the daily picks?",
      answer: "Once you sign up, you'll get immediate access to our web app that works on any device (desktop, tablet, or mobile). The app will show you the qualifying races for the day and will allow you to easily calculate your stake."
    },
    {
      question: "What happens after the 7-day free trial?",
      answer: "After your 7-day free trial, you'll be charged £19.99 per month to continue accessing the system. You can cancel at any time during the trial period if you decide it's not for you."
    },
    {
      question: "How much money do I need to start?",
      answer: "We recommend beginning with at least £250 to ensure that your stake sizes meet minimum thresholds of betting platforms. Our staking calculator will help you adjust your stake sizes based on the balance you choose to start with."
    },
    {
      question: "What support do you provide?",
      answer: "We provide email support to help you get started and answer any questions about using the system. Our web app also includes detailed user guides and tips."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <Link to="/" className="inline-block mb-8">
            <img
              src="/HRO-Logo-transparent-white-logo.png"
              alt="Horse Racing Oracle"
              className="h-12"
            />
          </Link>
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Frequently Asked Questions
          </h1>
        </div>

        {/* FAQ Section */}
        <div className="bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-200 pb-4 last:border-b-0 last:pb-0">
                  <button
                    className="w-full text-left"
                    onClick={() => setExpandedFAQ(expandedFAQ === index ? null : index)}
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="text-base font-medium text-gray-900">{faq.question}</h3>
                      <svg
                        className={`h-5 w-5 text-gray-500 transform transition-transform ${
                          expandedFAQ === index ? 'rotate-180' : ''
                        }`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </button>
                  {expandedFAQ === index && (
                    <p className="mt-2 text-sm text-gray-500">{faq.answer}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="text-center mt-8">
          <p className="text-base text-gray-600">
            If you have any further questions, please{' '}
            <Link to="/system/contact" className="text-indigo-600 hover:text-indigo-500 font-medium">
              Contact Us
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
} 